import { FixtureViewType } from '@cds/betting-offer';
import { EventModel, EventParticipantType } from '@frontend/sports/betting-offer/feature/model';

import { MyBetsEventModel } from '../../my-bets/models/my-bets-event.model';
import { ScoreboardViewModel } from './scoreboard.viewmodel';

export abstract class ScoreboardPairGameViewModel extends ScoreboardViewModel {
    protected scoreKey = 'score';

    protected constructor() {
        super();
    }

    player1 = '';
    player2 = '';
    eventName = '';
    leagueName = '';
    player1AwayIndicator: boolean;
    player2AwayIndicator: boolean;

    protected override __fillFromEvent(event: EventModel | MyBetsEventModel): void {
        super.__fillFromEvent(event);
        this.eventName = event.name;
        this.leagueName = event.league.name;

        if (event.participants.length) {
            this.player1 = event.participants[0].name;
            this.player2 = event.participants[1].name;
            this.player1AwayIndicator = event.viewType === FixtureViewType.American && event.participants[0].type === EventParticipantType.Away;
            this.player2AwayIndicator = event.viewType === FixtureViewType.American && event.participants[1].type === EventParticipantType.Away;
        }
    }
}
